import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";
import { startRegisterSearchResult } from "./searchResultActions";
import { dispatchSearchFilterResults } from "../helpers/searchFilterDispatch.helper";
import { resolveFlowListQueryFromState } from "../helpers/flowModuleListQueryHelper";

/*Reorganizados*/

/* Metodos Principales */
export const financialStartRegisterAdmin = (financial, navigate, returnTo) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_FINANCIAL}`,
      "add",
      financial,
      "POST"
    );

    const body = await resp.json();

     debugLogActions(':: financialActions, financialStartRegisterAdmin', { 'body': body });

    if (body.ok) {

      const financialSaved = body.financial;

      dispatch(financialRegisterAdmin(financialSaved));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            const nextPath = typeof returnTo === "string" && returnTo.startsWith("/")
              ? returnTo
              : "/specialist-financial";
            navigate(nextPath);
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const financialRegisterAdmin = (financial) => ({
  type: types.FINANCIAL_START_REGISTER_ADMIN,
  payload: financial,
});

export const financialStartUpdate = (financial, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_FINANCIAL}`,
        `update/${financial.id}`,
        financial,
        "PUT"
      );
      const body = await resp.json();

       debugLogActions(':: financialActions, financialStartUpdate', { 'body': body });

      if (body.ok) {
        dispatch(financialUpdated(financial));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        });

      } else {

        if (body.errors) {
          debugLogActions("inside errors", body.errors);
          const { catalogserie_id } = body.errors;

          if (catalogserie_id) {
            Swal.fire(t("titles.error"), catalogserie_id.msg, "error");
            
          }
        }

        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: financialActions, financialStartUpdate', { 'error': error });
    }
  };
};

const financialUpdated = (financial) => {
  return {
    type: types.FINANCIAL_UPDATE,
    payload: financial,
  };
};

export const financialStartDelete = (id, onDeleted) => {
  return async (dispatch, getState) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_FINANCIAL}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {
               debugLogActions(':: financialActions, financialStartDelete', { 'body': body });

              if (body.ok) {
                dispatch(financialDeleted(id));
                if (typeof onDeleted === "function") {
                  onDeleted();
                }
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: financialActions, financialStartDelete', { 'error': error });
    }
  };
};

const financialDeleted = (id) => {
  return {
    type: types.FINANCIAL_DELETE,
    payload: id,
  };
};

export const startLoadingFinancialsPaginated = (page, size) => {
  return async (dispatch, getState) => {
    const query = resolveFlowListQueryFromState(getState, 'financial');
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_FINANCIAL}`, `get/${page}/${size}${query}`);
    const body = await resp.json();

     debugLogActions(':: financialActions, startLoadingFinancialsPaginated', { 'body': body });

    if (body.ok) {
      dispatch(loadingFinancialsPaginated(body.financialsPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingFinancialsPaginated = (financialsPaginated) => ({
  type: types.FINANCIAL_START_LOADING_PAGINATED,
  payload: financialsPaginated,
});

export const startLoadingFinancialsByTextFinancialPaginated = (financial, page, size, catalogToFilter, indicatorToFilter = [], codeCiiuLevel1={}) => {
  return async (dispatch, getState) => {

      const searchInfo = {
      searchFinancialText: financial,
      codeCiiuLevel1: codeCiiuLevel1,
      catalogToFilter: catalogToFilter,
      indicatorToFilter: indicatorToFilter,
    };

    dispatch(financialIsLoading());

    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_FINANCIAL}`,
      `getByTextFinancial/${page}/${size}`,
      searchInfo,
      "POST"
    );
    const body = await resp.json();

     debugLogActions(':: financialActions, startLoadingFinancialsByTextFinancialPaginated', { 'body': body });

    if (body.ok) {

      dispatch(financialIsLoadingFinish());

      dispatchSearchFilterResults(dispatch, body.filterResults);

      body.financialsPaginated.financialsP.forEach(element => {
        element.isSelected = false;
        element.isCompared = false;
      });

      dispatch(loadingFinancialsByTextFinancialPaginated(body.financialsPaginated));

      const { totalItems, totalPages, currentPage, financialsP } = body.financialsPaginated;
      
            let index = 0;
            let registerIds = "";
            financialsP.forEach(element => {
      
              if (index === 0) {
                registerIds = registerIds.concat(element.id);
              } else {
                registerIds = registerIds.concat(";", element.id);
              }
      
              index = index + 1;
            });
      
            const state = getState();
            const { searchInfo } = state.searchInfo;
      
            const searchResult = {
              filter_results: body.filterResults,
              total_items: totalItems,
              total_pages: totalPages,
              current_page: currentPage,
              search_results_ids: registerIds,
              deleted: false,
              searchinfo_id: searchInfo.id
            }
      
            dispatch(startRegisterSearchResult(searchResult));

    } else {

      dispatch(financialIsLoadingFinish());
      
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const loadingFinancialsByTextFinancialPaginated = (financialsPaginated) => ({
  type: types.FINANCIAL_START_LOADING_FINANCIAL_PAGINATED,
  payload: financialsPaginated,
});

export const startSearchingFinancialsPaginated = (textSearch, page, size) => {
  
  return async (dispatch, getState) => {
    const query = resolveFlowListQueryFromState(getState, 'financial');
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_FINANCIAL}`,
      `search/${textSearch}/${page}/${size}${query}`
    );
    const body = await resp.json();

     debugLogActions(':: financialActions, startSearchingFinancialsPaginated', { 'body': body });

    if (body.ok) {
      dispatch(searchingFinancialsPaginated(body.financialsPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const searchingFinancialsPaginated = (financialsPaginated) => ({
  type: types.FINANCIAL_START_SEARCH_PAGINATED,
  payload: financialsPaginated,
});

export const selectFinancial = (financial) => ({
  type: types.FINANCIAL_SELECT,
  payload: financial,
});

export const cleanFinancialsPaginatedS = () => ({
  type: types.FINANCIAL_CLEAN_SEARCH_PAGINATED,
});

export const cleanFinancialsPaginatedP = () => ({
  type: types.FINANCIAL_CLEAN_PAGINATED,
});

export const financialSetSearchText = (searchText) => ({
  type: types.FINANCIAL_SET_SEARCH_TEXT,
  payload: searchText,
});

export const financialCleanSearchText = () => ({
  type: types.FINANCIAL_CLEAN_SEARCH_TEXT,
});

export const financialCleanSaved = () => ({
  type: types.FINANCIAL_CLEAN_SAVED,
});

//Si va Update 13 de Feb 2026
export const financialListUpdateSelected = (id) => ({
  type: types.FINANCIAL_LIST_UPDATE_SELECTED,
  payload: id
});

export const financialListSelectAllLimit = () => ({
  type: types.FINANCIAL_SELECT_ALL_LIMIT,
});

export const financialCleanAllSelected = () => ({
  type: types.FINANCIAL_CLEAN_ALL_SELECTED,
});

export const financialCleanAllSelectedWithoutList = () => ({
  type: types.FINANCIAL_CLEAN_ALL_WITHOUT_LIST,
});

export const financialIsLoading = () => ({
  type: types.FINANCIAL_IS_LOADING
});

export const financialIsLoadingFinish = () => ({
  type: types.FINANCIAL_IS_LOADING_FINISH
});


//NO van Update 13 de Feb 2026
export const financialGetMoreThanOneIsSelected = () => ({
  type: types.FINANCIAL_GET_MORE_THAN_ONE_SELECTED
});

export const financialGetNumberFinancialSelected = (countCompareFlag) => ({
  type: types.FINANCIAL_LIST_SET_NUMBER_SELECTED,
  payload: countCompareFlag
});

export const cleanSearchInformation = () => ({
  type: types.FINANCIAL_CLEAN_SEARCH_INFORMATION,
});


